export const NAME = 'param1'
export const EMAIL = 'param2'
export const SESSION_ID = 'param3'
export const EMP_NO = 'param4'
export const LOGIN_FORM_URL = 'https://njcmedia.njc.co.jp/auth/login2.php?'



// WEBPACK FOOTER //
// ./src/constants.js